import React from 'react';
import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';

const LanguageSwitch: React.FC = () => {
  const { i18n } = useTranslation();

  // Detected/cached language can be a regional code ("fr-FR", "en-US"), not
  // just the bare "fr"/"en" — a strict === here made the toggle sometimes
  // need two clicks. .startsWith() matches the convention already used
  // elsewhere in the app (ProductCard, ProductCatalog, QuoteForm).
  const isFr = i18n.language.startsWith('fr');

  const toggleLanguage = () => {
    i18n.changeLanguage(isFr ? 'en' : 'fr');
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-2 px-4 py-2 bg-forest-200 text-cream-50 rounded-full hover:bg-forest-100 transition-colors duration-300 shadow-soft"
    >
      <span className="text-sm font-medium">
        {isFr ? 'EN' : 'FR'}
      </span>
      <Languages className="h-4 w-4" aria-hidden="true" />
    </button>
  );
};

export default LanguageSwitch;